import React, { useRef, useState } from 'react';

import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import Modal from '@tds/community-modal';

import { StatusBarWrapper } from '../design/statusBar/css';
import { BoxWrapper } from './css';
import { useLocalizedStringsContext } from '../context/LocalizedStringsContext';
import stringInterpolation from '../utils/stringInterpolation';
import request from '../utils/request';
import { orderStatus } from '../utils/constant';

const FormButtonsMultisite = ({
  isLastStep,
  isSecondLastStep,
  nextStep,
  prevStep,
  saveAndExit,
  showSave,
  isSalesSupport,
  orderData,
  currentSite,
  totalNumberOfMultisites
}) => {
  const { status } = orderData;
  const localizedStrings = useLocalizedStringsContext();
  const {
    formButtons: {
      submitButtonLabel,
      continueButtonLabel,
      saveContinueLaterButtonLabel,
      deleteOrder,
      createNewOrder,
      backButtonLabel
    },
    summaryForm: { modalBody, modalClose },
    multisite: { continueToSiteLabel }
  } = localizedStrings;
  const [isModalOpen, setModalOpen] = useState(false);
  const history = useHistory();
  const focusElementOnClose = useRef(null);

  return (
    <StatusBarWrapper>
      <div id="footer-wrapper">
        <BoxWrapper>
          {isSalesSupport && isLastStep ? (
            <>
              <button
                type="button"
                onClick={() => {
                  if (orderData && orderData.id) {
                    request
                      .delete(`/orders/${orderData.id}/delete-order`)
                      .then(() => {
                        setModalOpen(true);
                      });
                  }
                }}
                className="frg-button color-purple"
              >
                {deleteOrder}
              </button>
              <button
                type="button"
                style={{ marginLeft: '1rem' }}
                onClick={() => history.push('/')}
                className="frg-button color-green"
              >
                {createNewOrder}
              </button>
              <Modal
                heading=""
                bodyText={stringInterpolation(
                  modalBody,
                  orderData && orderData.orderId
                )}
                confirmCTAText={modalClose}
                onConfirm={() => history.push('/')}
                onClose={() => history.push('/')}
                isOpen={isModalOpen}
                focusElementAfterClose={focusElementOnClose}
              />
            </>
          ) : (
            <>
              {showSave && (
                <button
                  type="button"
                  onClick={prevStep}
                  className="frg-button color-green"
                >
                  {backButtonLabel}
                </button>
              )}

              {showSave && !isLastStep && (
                <button
                  type="button"
                  onClick={saveAndExit}
                  style={{ marginLeft: '1em' }}
                  className="frg-button color-purple"
                >
                  {saveContinueLaterButtonLabel}
                </button>
              )}

              {(isSecondLastStep || isLastStep) &&
                currentSite !== totalNumberOfMultisites &&
                status !== orderStatus.waitingOnSales && (
                  <button
                    type="button"
                    onClick={e => nextStep(e)}
                    style={{ marginLeft: '1em' }}
                    className="frg-button color-green"
                  >
                    {continueToSiteLabel} {currentSite + 1}
                  </button>
                )}
              {((isSecondLastStep && currentSite === totalNumberOfMultisites) ||
                (!isSecondLastStep && !isLastStep) ||
                status === orderStatus.waitingOnSales) && (
                <button
                  type="button"
                  onClick={e => nextStep(e)}
                  style={{ marginLeft: '1em' }}
                  className="frg-button color-green"
                >
                  {continueButtonLabel}
                </button>
              )}

              {isLastStep && (
                <button
                  type="button"
                  onClick={e => nextStep(e)}
                  style={{ marginLeft: '1em' }}
                  className="frg-button color-green"
                >
                  {submitButtonLabel}
                </button>
              )}
            </>
          )}
        </BoxWrapper>
      </div>
    </StatusBarWrapper>
  );
};

FormButtonsMultisite.propTypes = {
  isLastStep: PropTypes.bool.isRequired,
  isSecondLastStep: PropTypes.bool.isRequired,
  nextStep: PropTypes.func.isRequired,
  prevStep: PropTypes.func.isRequired,
  saveAndExit: PropTypes.func.isRequired,
  showSave: PropTypes.bool,
  isSalesSupport: PropTypes.bool.isRequired,
  orderData: PropTypes.shape({
    id: PropTypes.number,
    orderId: PropTypes.string,
    status: PropTypes.string
  }).isRequired,
  currentSite: PropTypes.number.isRequired,
  totalNumberOfMultisites: PropTypes.number.isRequired
};

FormButtonsMultisite.defaultProps = {
  showSave: true
};

export default FormButtonsMultisite;
